import React, { useState, useEffect } from "react";
import { Badge, Box, Grid } from "@mui/material";
import { Formik } from "formik";

import BasicFilters from "./BasicFilters";
import HeaderFilters from "./HeaderFilters";
import GpiFilters from "./GpiFilters";
import CustomerFilters from "./CustomerFilters";
import InstitutionFilters from "./InstitutionFilters";
import Header from "../../../Layouts/Components/Header";
import TextButton from "../TextButton";
import SecondaryButton from "../SecondaryButton";
import { allFiltersSchema } from "../../../utils/filters";
import { getDirtyValuesCount, initialFilters } from "../../../utils/filters";
import ToggleMessageFilter from "./ToggleMessageFilter";
import { ToggleMessageTypeName } from "../../../utils/constantToggleMessageType";
import { loadMessagesTypes } from "../../Swift/state/actions";
import { useDispatch } from "react-redux";
const initialValues = initialFilters;

const AllFilters = ({
  headLine,
  filters,
  handleFiltersChange,
  handleResetFilters,
  handleToggleRenderAllFilters,
  type,
}) => {
  const currentValues = filters;
  const dispatch = useDispatch();

  const [value, setValue] = useState("MT");

  const handleChange = (event) => {
    setValue(event.target.value);
    dispatch({ type: "FILTER_MX", payload: event.target.value });
    //dispatch(loadMessagesTypes());
  };

  let labelToggle = ToggleMessageTypeName[value];
  console.log(labelToggle);
  return (
    <Formik
      initialValues={{
        ...currentValues,
      }}
      validationSchema={allFiltersSchema}
      onSubmit={(values) => {
        handleFiltersChange({ ...values });
        handleToggleRenderAllFilters();
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ ...formikProps }) => {
        const { values, submitForm, resetForm } = formikProps;

        return (
          <Grid
            container
            sx={{ padding: "2rem", width: "100%" }}
            direction="column"
            spacing={2}
          >
            <Grid item xs={12}>
              <Header
                headLine={headLine}
                headlineActions={() => (
                  <TextButton
                    sx={{ color: "#050D2E" }}
                    endIcon={
                      <Badge
                        badgeContent={getDirtyValuesCount(
                          { ...initialValues },
                          { ...initialValues, ...values }
                        )}
                        sx={{
                          margin: 1,
                          "& .MuiBadge-badge": {
                            color: "#1C2238",
                            backgroundColor: "#D4EDF3",
                          },
                        }}
                      />
                    }
                    onClick={() => {
                      resetForm({ ...initialValues });
                      handleResetFilters();
                    }}
                  >
                    Clear
                  </TextButton>
                )}
              >
                <Box sx={{ display: "flex", gap: 1 }}>
                  <SecondaryButton
                    sx={{
                      backgroundColor: "var(--primary)",
                      "&:hover": { backgroundColor: "var(--primary)" },
                    }}
                    onClick={() => {
                      submitForm();
                    }}
                  >
                    Apply Filters
                  </SecondaryButton>
                </Box>
              </Header>
            </Grid>
            <ToggleMessageFilter value={value} handleChange={handleChange} />
            <BasicFilters {...formikProps} type={type} />
            <HeaderFilters Labels={labelToggle} {...formikProps} />
            <GpiFilters {...formikProps} />
            <CustomerFilters Labels={labelToggle} {...formikProps} />
            <InstitutionFilters Labels={labelToggle} {...formikProps} />
          </Grid>
        );
      }}
    </Formik>
  );
};

export default AllFilters;
